// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".doc-preview-container[data-v-7fd3b633]{width:100%;height:100%;overflow:hidden;position:relative}.doc-preview-content[data-v-7fd3b633]{transform-origin:top left}", ""]);
// Exports
module.exports = exports;
